import { Injectable } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { UserInfoService } from './user-info.service';

@Injectable({
  providedIn: 'root',
})
export class RequiredConfigurationService {
  readonly configurations$: Observable<(object | null)[]>;

  constructor(
    private userInfoService: UserInfoService,
  ) {
    this.configurations$ = combineLatest([
      this.userInfoService.userInfo$,
    ]);
  }
}
